module.exports = __webpack_public_path__ + "media/images/top/seminars/top/img_flow03-b41c1c2bc1be549933407176267a7451.png";